import PropTypes from 'prop-types';

import Box from './layout/Box';

const Section = ({ children, className }) => {
  return <Box className={`flex-column mb-3 ${className}`}>{children}</Box>;
};

Section.defaultProps = {
  className: '',
};

Section.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Section;
